import React from "react";

import { DomainsCircle } from "src/pages/reports/fsci/all/graphics/domains_circle";

/*
 * Main
 */

export const Overview = (): React.ReactElement => {
    return (
        <div className="report-overview-wrapper">
            <p>
                Thank you for your school’s participation in the Flourishing School Culture Instrument (FSCI). Your
                school’s profile, based on the results of the FSCI as mapped on to the validated Flourishing School
                Culture Model (FSCM), is designed to highlight areas of existing strength as well as opportunities for
                growth and improvement. Insights from the FSCI have the potential to inform strategic planning and
                budgeting, professional development decisions, programmatic priorities, marketing and promotional
                efforts, and much more.
            </p>
            <p>
                The "View All" section lets you see multiple reports together to help your team understand your
                organization's changes over time. To explore benchmark data for all domains and related constructs,
                simply click on the interactive graphic or blue button labeled "Explore the Five Domains" below.
            </p>
            <p>
                As with most institutional survey research, it is important to note that schools will benefit the most
                fully when the reported findings are used to generate reflection, dialogue, and collaborative planning
                for the present and the future. We pray the insights in this report will help your school to continue to
                grow in the five domains of Christian school flourishing, and that ultimately, “May the Lord cause you
                to flourish, both you and your children” (Psalm 115:14 NIV).
            </p>

            <div className="overview-divider" />

            <h2 className="large">Explore your results by domain.</h2>
            <p className="text-align-center">Click on the interactive graphic below to navigate between domains.</p>

            <DomainsCircle />
        </div>
    );
};
